import { type FunctionComponent } from 'react';
import { type IconProps } from '../types';
import { IconWrapper } from '../style';

export const Clock: FunctionComponent<IconProps> = ({
  color,
  rotation,
  width = '24px',
  height = '24px',
  cursor,
}: IconProps) => (
  <IconWrapper width={width} height={height} cursor={cursor}>
    <svg
      width="100%"
      height="100%"
      xmlns="http://www.w3.org/2000/svg"
      transform={`rotate(${rotation ?? 0})`}
      fill="none"
      viewBox="0 0 51 51"
    >
      <mask
        id="mask0_clock_0"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="51"
        height="51"
      >
        <rect width="51" height="51" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_clock_0)">
        <path
          d="M27.0935 24.8543V16.4686C27.0935 16.0171 26.9407 15.6385 26.6351 15.3328C26.3294 15.0275 25.9508 14.8749 25.4993 14.8749C25.0474 14.8749 24.6689 15.0275 24.364 15.3328C24.0587 15.6385 23.9061 16.0171 23.9061 16.4686V25.3447C23.9061 25.5947 23.9525 25.837 24.0453 26.0714C24.1377 26.3059 24.2834 26.5226 24.4825 26.7217L31.7605 33.9997C32.0545 34.294 32.4242 34.4446 32.8698 34.4513C33.3153 34.458 33.692 34.3075 33.9997 33.9997C34.3075 33.692 34.4614 33.3187 34.4614 32.8799C34.4614 32.4414 34.3075 32.0683 33.9997 31.7605L27.0935 24.8543ZM25.5035 45.6871C22.7113 45.6871 20.0868 45.1573 17.6299 44.0977C15.1731 43.038 13.0361 41.5999 11.2189 39.7834C9.40164 37.9669 7.96284 35.8308 6.90248 33.375C5.84246 30.9192 5.31246 28.2954 5.31246 25.5035C5.31246 22.7113 5.84229 20.0868 6.90195 17.6299C7.9616 15.1731 9.39969 13.0361 11.2162 11.2189C13.0327 9.40164 15.1688 7.96284 17.6246 6.90248C20.0804 5.84246 22.7042 5.31246 25.4961 5.31246C28.2883 5.31246 30.9128 5.84229 33.3697 6.90195C35.8265 7.9616 37.9635 9.39969 39.7808 11.2162C41.598 13.0327 43.0368 15.1688 44.0971 17.6246C45.1571 20.0804 45.6871 22.7042 45.6871 25.4961C45.6871 28.2883 45.1573 30.9128 44.0977 33.3697C43.038 35.8265 41.5999 37.9635 39.7834 39.7808C37.9669 41.598 35.8308 43.0368 33.375 44.0971C30.9192 45.1571 28.2954 45.6871 25.5035 45.6871ZM25.4998 42.4997C30.2102 42.4997 34.2211 40.844 37.5325 37.5325C40.844 34.2211 42.4997 30.2102 42.4997 25.4998C42.4997 20.7894 40.844 16.7785 37.5325 13.4671C34.2211 10.1557 30.2102 8.49993 25.4998 8.49993C20.7894 8.49993 16.7785 10.1557 13.4671 13.4671C10.1557 16.7785 8.49993 20.7894 8.49993 25.4998C8.49993 30.2102 10.1557 34.2211 13.4671 37.5325C16.7785 40.844 20.7894 42.4997 25.4998 42.4997Z"
          fill={color ?? 'currentColor'}
        />
      </g>
    </svg>
  </IconWrapper>
);
